import { IDocumentType } from '../../common/types';

export const mergeDocumentOptions = (
  available: IDocumentType[],
  selected: IDocumentType[],
) => {
  const options = [...available];
  const ids = new Set(options.map(documentType => documentType.id));

  selected.forEach(documentType => {
    if (!ids.has(documentType.id)) {
      options.push(documentType);
      ids.add(documentType.id);
    }
  });

  return options;
};
export const toggleDocumentSelection = (
  selected: IDocumentType[],
  documentType: IDocumentType,
) => {
  const checked = selected.some(item => item.id === documentType.id);

  return checked
    ? selected.filter(item => item.id !== documentType.id)
    : [...selected, documentType];
};
